import type { BuffSnapshot } from './types'

/** Application-owned provider. PiP never starts a second monitor or speech queue. */
let source: (() => BuffSnapshot) | null = null
let heartbeat: (() => void) | null = null
let reorder: ((id: string, index: number) => Promise<void>) | null = null
export function setBuffOverlaySource(get: (() => BuffSnapshot) | null, pulse: (() => void) | null = null, move: typeof reorder = null): void { source = get; heartbeat = pulse; reorder = move }
export async function reorderBuffOverlay(id: string, index: number): Promise<void> { await reorder?.(id, index) }
export function getBuffOverlay(): BuffSnapshot | null { return source?.() ?? null }
export function pulseBuffOverlay(): void { heartbeat?.() }
